import qs from 'qs';
import { getAccessToken } from '../auth/userManager';
import { client } from './generated';

client.setConfig({
  querySerializer: (query) => qs.stringify(query, { encode: true }),
});

client.interceptors.request.use(async (request) => {
  const token = await getAccessToken();
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }
  return request;
});
